import React from 'react';

/**
 * Small inline SVG icon set for the interview-report modal (sidebar tabs, section empty-states,
 * download cards, verification). Stroke icons on a 24×24 grid; `fill` variants where noted.
 * Kept as one component so every icon shares sizing/stroke and there are no emoji.
 */
const STROKE = {
  report: 'M8 4h6l4 4v12a1 1 0 01-1 1H8a1 1 0 01-1-1V5a1 1 0 011-1zM14 4v4h4M9.5 13h5M9.5 16h5',
  screen: 'M4 5h16v10H4zM9 19h6M12 15v4',
  camera: 'M4 8h3l1.5-2h7L17 8h3v11H4zM12 16.5a3 3 0 100-6 3 3 0 000 6z',
  verification: 'M12 3l7 3v5c0 4-3 6.8-7 8-4-1.2-7-4-7-8V6zM9.2 11.8l2 2 3.6-3.6',
  download: 'M12 4v10m0 0l-3.5-3.5M12 14l3.5-3.5M5 19h14',
  film: 'M4 5h16v14H4zM4 9h16M4 15h16M8 5v14M16 5v14',
  clock: 'M12 21a9 9 0 100-18 9 9 0 000 18zM12 8v4l3 2',
  archive: 'M4 7h16v3H4zM5 10h14v9H5zM9.5 13h5',
  warning: 'M12 4l9 16H3zM12 10v4M12 17.5v.5',
  id: 'M4 6h16v12H4zM7 10.5a1.8 1.8 0 100-3.6 1.8 1.8 0 000 3.6zM4.8 15.5a3 3 0 014.4 0M13 9h4M13 12h4M13 15h2.5',
  mic: 'M12 4a2.5 2.5 0 012.5 2.5v5a2.5 2.5 0 01-5 0v-5A2.5 2.5 0 0112 4zM6.5 11a5.5 5.5 0 0011 0M12 16.5V20M9.5 20h5',
  pdf: 'M8 3h6l4 4v13a1 1 0 01-1 1H8a1 1 0 01-1-1V4a1 1 0 011-1zM14 3v4h4M9 14h1.2a1.2 1.2 0 000-2.4H9V17M13 11.6v5M13 11.6h2',
  zip: 'M4 6a1 1 0 011-1h5l2 2h7a1 1 0 011 1v10a1 1 0 01-1 1H5a1 1 0 01-1-1zM12 9v1M12 11.5v1M12 14v1',
  wifi: 'M4.5 9a11 11 0 0115 0M7.5 12a7 7 0 019 0M10.5 15a3 3 0 013 0M12 18h.01',
  check: 'M5 13l4 4L19 7',
  close: 'M6 6l12 12M18 6L6 18',
};
const FILL = {
  play: 'M8 5v14l11-7z',
};

export const Icon = ({ name, className = 'h-5 w-5' }) => {
  if (FILL[name]) {
    return (
      <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
        <path d={FILL[name]} />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor"
      strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d={STROKE[name] || ''} />
    </svg>
  );
};

export default Icon;
